module.exports = __webpack_public_path__ + "img/hb-bg.daff7958.png";